import React from "react";
import TextField from "../../Reusable/TextInput";
import Button from "../../Reusable/Button";
import { useForm } from "react-hook-form";
import usePostHook from "../../../customHooks/usePostHook";
import APIS from "../../../constant/EndPoint";
import { queryClient } from "../../../router/ConsignmentRouter";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { Dialog } from "@headlessui/react";
const EditDeliveryCharge = (props: any) => {
  const { register, handleSubmit, setError, clearErrors } = useForm({
    defaultValues: async () => {
      return {
        charge: props?.chargevalue,
      };
    },
  });
  const {
    id,
    disabled = false,
    setOpenDeliveryModal,
    openDeliveryModal,
  } = props;
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });

  const handleDeliverychargeEdit = async (value) => {
    const url = `${APIS.ORDER}update-delivery-charge/`;
    let formData = {
      ...value,
      order: id,
    };
    try {
      const res = await mutateAsync({ url, formData, setError, clearErrors });
      if (res.status === 200 || res.status === 201) {
        setOpenDeliveryModal(!openDeliveryModal), queryClient.refetchQueries();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data: any) => handleDeliverychargeEdit(data))}
      autoComplete="off"
    >
      <div>
        <TextField
          register={register("charge")}
          placeholder={"Enter the Delivery Charge"}
        />
        <div className={tw`flex justify-end   w-full`}>
          <div className={tw`w-[100px]`}>
            <Button
              label={"Update"}
              isLoading={isPostLoading}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default EditDeliveryCharge;
